define('view/disclosure/modals/remove.reviewer.confirmation.modal',['require','exports','module','underscore','uikit/uikit','backbone.radio','blockit'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      UIKit   = require('uikit/uikit'),
      Radio   = require('backbone.radio'),
      BlocKit = require('blockit');

  var RemoveReviewerConfirmationModal = UIKit.Modal2.extend({
    options: _.extend({}, UIKit.Modal2.prototype.options, {
      basic: true,
      closable: true,
      size: 'small',
    }),

    header: function() {
      var model = this.getOption('model');

      return {
        type: UIKit.Modal2.HeaderView,
        text: 'Remove ' + model.get('disclosureReviewerName'),
      };
    },

    content: function() {
      var model = this.getOption('model');

      return {
        type: UIKit.Modal2.SimpleContentView,
        icon: 'warning sign icon',
        text:
          'You are about to remove ' +
          model.get('disclosureReviewerName') +
          ' as a reviewer for this disclosure.  Are you sure?',
      };
    },

    actions: function() {
      return {
        components: [
          {
            type: UIKit.Modal2.DenyButtonView,
            text: 'Cancel',
            inverted: true,
            color: 'basic',
            name: 'denyButton',
          },
          {
            type: UIKit.Modal2.ConfirmButtonView,
            color: 'positive',
            text: 'Confirm',
            name: 'confirmButton',
            disclosureAssignmentDetailModel: this.getOption('disclosureAssignmentDetailModel'),
            disclosureModel: this.getOption('model'),
            onPress: function() {
              var previousReviewerModel = Radio.request('AppKit.resourceService', 'resource', 'previousReviewerModel');

              this.disclosureAssignmentDetailModel.set({
                disclosureReviewer: null,
                documentId: this.disclosureModel.get('id'),
              });

              this.disclosureAssignmentDetailModel
                .save()
                .promise()
                .bind(this)
                .then(function() {
                  if (
                    previousReviewerModel.get('type') === 'lastAssignedReviewer' &&
                    !_.isNull(previousReviewerModel.get('user'))
                  ) {
                    this.disclosureAssignmentDetailModel.set({
                      disclosureReviewer: { id: previousReviewerModel.get('user') },
                    });
                    this.disclosureAssignmentDetailModel.save();
                  } else {
                    this.disclosureModel.fetch();
                  }
                })
                .catch(function(error) {
                  console.error('An error occurred while saving or fetching disclosureAssignmentDetailModel:', error);
                })
            },
          },
        ],
      };
    },
  });

  module.exports = RemoveReviewerConfirmationModal;
});

